'use client';
import { useState } from 'react';
import * as Styled from './styled';
import { ISchemaSummary } from '@/lib/repositorySchemasApi';

const SchemaFields: React.FC<{
  schema: ISchemaSummary;
  closedColumnLimit?: number;
}> = ({ schema, closedColumnLimit }) => {
  const [open, setOpen] = useState(!closedColumnLimit);

  const toggleOpen = () => setOpen(!open);
  const visibleFields = open ? schema.fields : schema.fields.slice(0, closedColumnLimit);
  const shouldDisplayToggle = !!closedColumnLimit && (schema.fields.length > visibleFields.length || !!open);

  return (
    <Styled.SchemaFields className="mono">
      <div className="heading">
        <div>column</div>
        <div>type</div>
      </div>
      {visibleFields.map((field) => (
        <div key={field.name}>
          <div>{field.name}</div>
          <div>{field.dtype}</div>
        </div>
      ))}

      {shouldDisplayToggle && (
        <div className="toggle-row" onClick={toggleOpen}>
          <a className="link">
            {open
              ? `- hide ${schema.fields.length - closedColumnLimit} columns`
              : `+ show ${schema.fields.length - closedColumnLimit} more columns`}
          </a>
        </div>
      )}
    </Styled.SchemaFields>
  );
};

export default SchemaFields;
